import {
  Building2,
  ClipboardCheck,
  MapPin,
  MessagesSquare,
  Users,
  type LucideIcon,
} from "lucide-react";
import type { WC_LAST_STEP, WcStepId } from "@/lib/submissions/wc/review";

/** Each Workers' Comp step's icon (BRK-S355; Nav, 2026-10-14: "we need a logo
 *  for each step on the header"): one map, so a step shows the same icon in
 *  the stepper, beside its heading and its sub-steps' headings, and wherever
 *  else the step is named. The last step's is a conversation: each carrier's
 *  own questions (BRK-S387). */
export const WC_STEP_ICONS: Readonly<
  Record<WcStepId | typeof WC_LAST_STEP, LucideIcon>
> = {
  business: Building2,
  locations: MapPin,
  people: Users,
  questions: ClipboardCheck,
  "carrier-questions": MessagesSquare,
};
